import { Pipe, PipeTransform } from '@angular/core';
import { LookupService } from '../service/lookup.service';

@Pipe({
    name: 'errorStatus',
    standalone: true
})

export class ErrorStatusPipe implements PipeTransform {

    constructor(private lookupService: LookupService) { }

    transform(value: string | string[], ...args: unknown[]): string {
        if (Array.isArray(value)) {
            return value.map(s => this.lookupService.translateErrorStatus(s)).join(', ');
        }
        return this.lookupService.translateErrorStatus(value);
    }
}
